const { get } = require('@ebay/str-ui-utils/retriever');

function getSid(input, textSpan) {
    const trkData = getTrackingData(input, textSpan);

    return get(trkData, 'eventProperty.sid') || get(trkData, '0.eventProperty.sid');
}

function getNNSid(input, textSpan) {
    const trkData = getTrackingData(input, textSpan);

    return get(trkData, 'eventProperty.nnsid') || get(trkData, '0.eventProperty.nnsid');
}

function getTrackingData(input, textSpan) {
    const inputTracking = get(input, 'tracking') || get(input, 'trackingList');
    const textSpanTracking = get(textSpan, 'action.tracking') || get(textSpan, 'action.trackingList.0');

    return inputTracking || textSpanTracking;
}

module.exports = { getSid, getNNSid, getTrackingData };
